import React from 'react';

// Sello botánico — elemento de firma que se repite como acento y separador
// entre secciones. Reemplaza el uso de emoji (🌿) por una marca propia.
export default function LeafMark({ size = 22, color = 'var(--forest)', style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style} aria-hidden="true">
      <path
        d="M4 20C4 11 9 5 20 4C19 15 13 20 4 20Z"
        stroke={color} strokeWidth="1.4" strokeLinejoin="round"
      />
      <path d="M5.5 18.5C9 14.5 12.5 11.5 17.5 7" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function Eyebrow({ children, color = 'var(--terra)', align = 'center' }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: align === 'center' ? 'center' : 'flex-start',
      gap: 8, marginBottom: 10, textAlign: align,
    }}>
      <LeafMark size={14} color={color} />
      <span style={{
        fontFamily: "'AvenirCondensed', var(--font-body)", fontSize: 14, letterSpacing: 1.4,
        textTransform: 'uppercase', color, fontWeight: 600,
      }}>
        {children}
      </span>
    </div>
  );
}

// Separador de sección con el sello repetido — sustituye a los <hr> genéricos
export function SectionDivider() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '4px 0 24px' }}>
      <span style={{ width: 28, height: 1, background: 'rgba(28,58,30,0.18)' }} />
      <LeafMark size={16} color="var(--sage)" />
      <span style={{ width: 28, height: 1, background: 'rgba(28,58,30,0.18)' }} />
    </div>
  );
}
